<template>
  <div>
    <ModalWindow v-model="showModal">
      <v-card-title>
        <p class="headline font-weight-bold mb-0">Набір даних {{ bankName }}</p>
        <v-spacer />
        <ActionsModalWindow @close="showModal = false" />
      </v-card-title>
      <v-row>
        <v-col>
          <v-data-table
            :items="[value]"
            class="elevation-1"
            hide-default-footer
            hide-default-header
          >
            <template v-slot:item="{ item }">
              <tr v-for="(it, index) in item" :key="`item-${index}`">
                <td>{{ infoDict[index] }}</td>
                <td>{{ item[index] }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </ModalWindow>
    <v-icon color="#D4CECD" @click="showModal = true">
      info
    </v-icon>
  </div>
</template>

<script>
import { infoDict } from "@/helpers";
import ModalWindow from "@/components/ModalWindow.vue";

export default {
  components: {
    ModalWindow,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow");
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    bankName: {
      type: String,
      default: "Приват24",
    },
  },
  data: () => ({
    showModal: false,
  }),
  computed: {
    infoDict() {
      return infoDict;
    },
  },
};
</script>
